import httpClient from './httpClient';
import { ENDPOINT_API } from '../../enums/endpoint';

const getProductStatus = () => httpClient.get(`${ENDPOINT_API.DASHBOARD}/product-view`);
const getProductOverview = () => httpClient.get(`${ENDPOINT_API.DASHBOARD}/overview`);
const getChannelStockStatus = () => httpClient.get(`${ENDPOINT_API.DASHBOARD}/channel-stock`);
const getFastMoveProduct = (params = {}) => httpClient.get(`${ENDPOINT_API.DASHBOARD}/fast-move-product`, { params });


export {
	getProductStatus,
	getProductOverview,
	getChannelStockStatus,
	getFastMoveProduct,
};
